// extracted by mini-css-extract-plugin
export default {"summary":"BasicObjectSummary_summary__ogs2l"};